<template>
        <div>
            <div class="form-actions">
                <b-button variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
            </div>

            <main-dialog title="Context" v-model="editor.show" @ok="save" ok-only ok-title="Save">
                <b-row v-for="(c, index) in context" :key="index">
                    <b-col md="4">
                        <InputField :name="`${c.key}_${index}`"
                        v-model="c.key"
                        :rules="{placeholder: 'key', length: {min: 1}}"
                        list="commands"
                        />

                        <datalist id="commands">
                            <option :value="k" v-for="(k, index) in commands" :key="index" />
                        </datalist>
                    </b-col>
                    <b-col md="6">
                        <InputField :name="`${c.key}_${index}_value`"
                        v-model="c.value"
                        :rules="{placeholder: 'value', length: {min: 1}}"
                        list="placeholders"
                        />

                        <datalist id="placeholders">
                            <option :value="p" v-for="p in placeholders" :key="p"/>
                        </datalist>
                    </b-col>
                    <b-col md="2">
                        <i class="fa fa-close" @click="remove(c)"></i>
                    </b-col>
                </b-row>

                <i class="fa fa-plus" @click="add"></i>

                <br />
                <br />

                <HowItWorks endpoint="docs#platform-components-fields-context" />

            </main-dialog>
        </div>
</template>

<style scoped>
.fa-close {
    margin-top: 20px;
}
</style>

<script>
import _ from 'lodash'
import Input from "@/components/form/Input"
import HowItWorks from "../../elements/HowItWorks"

export default {
    components: {
        InputField: Input,
        HowItWorks
    },
    props: {
        fields: {
            type: Array
        },
        value: {
            type: Array
        },
        field: {
            type: Object
        }
    },
    methods: {
        save(modal) {
            this.context = this.context.filter(c => {
                return c.key != '' && c.value != ''
            })
        },

        add() {
            this.context.push({
                key: '',
                value: ''
            })
        },

        remove(f) {
            this.context = this.context.filter(c => {
                return c.key != f.key
            })
        }
    },
    data: function() {
        return {
            editor: {
                show: false,
            },
            options: {
                select: {
                    relation: ["filter:"]
                },
                picker: {
                    datetime: ["filter:"]
                }
            }

        }
    },
    computed: {
        context: {
           get() {
                return this.value || [{
                    key: '',
                    value: ''
                }]
           },

           set(val) {
               this.$emit("input", val)
           }

        },

        placeholders() {
            return this.fields.map(f => {
                return "{{"+ f.key +"}}"
            })
        },

        commands() {
            let keys = ["var:"]

            if (this.options[this.field.module] !== undefined) {
                let mod = this.options[this.field.module];

                if (mod[this.field.type] !== undefined) {
                   keys = keys.concat(mod[this.field.type])
                }
            }

            return keys
        }
    }
}
</script>
